import React from 'react'
import { todayIso } from './dates'

export interface Now {
  date: string // the device's "YYYY-MM-DD", as todayIso
  minute: number // minutes since that day's midnight
}

export function nowOf(d: Date = new Date()): Now {
  return { date: todayIso(d), minute: d.getHours() * 60 + d.getMinutes() }
}

// useNow is the device's date and minute, moved on at each new minute, for
// the calendar's line at the current time.
export function useNow(): Now {
  const [now, setNow] = React.useState(nowOf)
  React.useEffect(() => {
    let timer: ReturnType<typeof setTimeout>
    const tick = () => {
      setNow(nowOf())
      timer = setTimeout(tick, 60_000 - (Date.now() % 60_000))
    }
    timer = setTimeout(tick, 60_000 - (Date.now() % 60_000))
    return () => clearTimeout(timer)
  }, [])
  return now
}
